import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { selectGetPartnerProfileConfigState, selectPartnerProfileConfig } from '../../../../store/slices/dashboardSlice';
import { getPartnerProfileConfig } from '../../../../store/thunks/dashboardThunk';
import { usePartnerProfile } from '../Enrollment/usePartnerProfile';
import { Notfound } from '../../../NotFound';
import { PartnerHeader } from './PartnerHeader';
import { PartnerDetails } from './PartnerDetails';
import PartnerLoadingSkeleton from './PartnerLoadingSkeleton';

export default function PartnerProfileComponent() {
  const dispatch = useAppDispatch();
  const getPartnerProfileConfigState = useAppSelector(selectGetPartnerProfileConfigState);
  const profileData = useAppSelector(selectPartnerProfileConfig);
  const partnerProfile = usePartnerProfile();
  const [hasError, setHasError] = useState(false);

  const partnerId = partnerProfile?.id;

  useEffect(() => {
    // Reset error state on partner change
    setHasError(false);

    if (partnerId) {
      dispatch(getPartnerProfileConfig(partnerId))
        .unwrap()
        .catch(() => {
          setHasError(true);
        });
    } else {
      setHasError(true);
    }
  }, [partnerId, dispatch]);

  const renderContent = () => {
    // Show 404 for actual errors (invalid partner, fetch failure)
    if (hasError) {
      return <Notfound />;
    }

    // Show loading skeleton until the profile config has actually loaded
    if (
      getPartnerProfileConfigState === 'pending' ||
      profileData?.id !== partnerId ||
      !profileData?.config
    ) {
      return <PartnerLoadingSkeleton />;
    }

    // Only after data loads, check if profile is disabled
    if (!profileData.config.isProfileEnabled) {
      return <Notfound />;
    }

    // Show partner details
    return (
      <PartnerDetails
        partnerId={partnerProfile?.id || ''}
        partnerName={partnerProfile?.partnerName}
        partnerCode={partnerProfile?.partnerCode}
        partnerSource={partnerProfile?.partnerSource}
        isLocked={partnerProfile?.isLocked}
        requiresSalesContact={partnerProfile?.requiresSalesContact}
      />
    );
  };

  return (
    <>
      <PartnerHeader />
      {renderContent()}
    </>
  );
}
